document.addEventListener(
    'DOMContentLoaded',
    () => {
        const select = document.querySelector(
            'select.js-form-show-fields',
        ) as HTMLSelectElement;
        if (select !== null && select !== undefined) {
            const wrapper = select?.closest('.form-wrapper');
            const formLines = wrapper?.querySelectorAll('.form__line');
            select?.addEventListener('change', () => {
                const value = select.value;
                if (value) {
                    wrapper?.classList.add('form-wrapper--wide');
                    wrapper?.classList.remove('form-wrapper--hide-fields');
                } else {
                    wrapper?.classList.remove('form-wrapper--wide');
                    wrapper?.classList.add('form-wrapper--hide-fields');
                }
                formLines.forEach((item) => {
                    if (item.getAttribute('data-select-value-hide') === value) {
                        item.classList.add('hide');
                    } else {
                        item.classList.remove('hide');
                    }
                });
                window.dispatchEvent(new Event('resize'));
            });
        }
    },
    { once: true },
);
